
import { defineComponent } from 'vue'
import { Chart, registerables } from 'chart.js'
import { colors } from '@/data/colors'
Chart.register(...registerables)

export default defineComponent({
  props: {
    langs: {
      type: Object as () => {
        [key: string]: number
      },
      required: true,
    },
  },
  data() {
    return {
      key: 0,
      colors,
      array: [] as [string, number][],
      data: {}
    }
  },
  mounted() {
    // sorting array
    for (const lang in this.langs) {
      this.array.push([lang, this.langs[lang]])
    }
    this.array.sort((a: [string, number], b: [string, number]) => b[1] - a[1])
  },
})
